import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页',
    component: Home,
  },
  {
    path: '/about',
    name: '走进佳驰',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    // children: [
    //   {
    //     path: 'index',
    //     name: "关于佳驰",
    //     component: () => import('../components/about/index.vue'),
    //   },
    //   {
    //     path: 'history',
    //     name: "发展大事记",
    //     component: () => import('../components/about/history.vue')
    //   },
    //   {
    //     path: 'cooperative',
    //     name: "合作伙伴",
    //     component: () => import('../components/about/cooperative.vue')
    //   }
    // ]
  },
  {
    path: '/news',
    name: "新闻中心",
    component: () => import('../views/news-center.vue'),
    children: [
      {
        path: '/news/company',
        name: "公司新闻",
        component: () => import('../components/news-center/company.vue'),
        children: [{
          path: 'detail',
          name: '新闻详情',
          component: () => import('../components/news-center/news-detail.vue'),

        }]
      },
      {
        path: '/news/industry',
        name: "技术动态",
        component: () => import('../components/news-center/industry.vue'),
        children: [{
          path: 'detail',
          name: '新闻详情',
          component: () => import('../components/news-center/news-detail.vue')
        }]
      }
    ]
  },
  {
    path: '/product',
    name: '民用产品',
    component: () => import('../views/product.vue'),
    children: [
      {
        path: 'detail',
        name: '产品详情',
        component: () => import('../components/product/detail.vue')
      }
    ]
  },
  // {
  //   path: '/case',
  //   name: '服务能力',
  //   component: () => import('../views/case.vue'),
  // },
  {
    path: '/investorRelations',
    name: '投资者关系',
    component: () => import('../views/InvestorRelations.vue'),
    children: [
      {
        path: '',
        name: "投资者热线",
        component: () => import('../components/investorRelations/InvestorHotline.vue'),
      },
      {
        path: '/Announcements',
        name: "公告信息",
        component: () => import('../components/investorRelations/Announcements.vue')
      },
      {
        path: '/StockInfo',
        name: "股票信息",
        component: () => import('../components/investorRelations/StockInfo.vue')
      }
    ]
  },
  {
    path: '/joinUs',
    name: '佳驰招聘',
    component: () => import('../views/joinUs.vue'),
  }
  , {
    path: '/concact',
    name: '联系我们',
    component: () => import('../views/concact.vue'),
  }
]
routes.forEach((val, index) => {
  val.meta = val.meta || {}
  val.meta.id = index
  if (val.children) {
    val.children.forEach((item, idx) => {
      item.meta = item.meta || {}
      item.meta.id = index
      item.meta.parent = index
      if (item.children) {
        item.children.forEach((i, idx) => {
          i.meta = i.meta || {}
          i.meta.id = index
          i.meta.parent = index
        })
      }
    })
  }
})
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  document.getElementsByTagName('title')[0].innerHTML = '成都佳驰电子科技股份有限公司'
  window.scrollTo(0, 0)
  next()
})
export default router
